import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/app';
import { PostHogProvider } from '@posthog/react'

import './css/tokens.css'
import './css/fonts.css'

const options = {
  api_host: "https://us.i.posthog.com",
  defaults: '2026-01-30',
}


ReactDOM.render(
  <PostHogProvider apiKey="phc_wkQxJT6qwC4c7AVAjibM6hfK6d9vrCzpclwZXFb6aFF" options={options}>
  <App></App>,
  </PostHogProvider>,
  document.getElementById('root')
);

const welcome = () => console.log('Welcome to Gravity 🚀')
welcome('de529c70-eb80-4dfb-9540-5075db7545bf')